import { StanModal } from '@/components';

export interface DeleteConfirmationModalProps {
    isOpen: boolean;
    itemTitle?: string;
    itemType?: 'product' | 'section';
    isDeleting?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function DeleteConfirmationModal({
    isOpen,
    itemTitle,
    itemType = 'product',
    isDeleting = false,
    onConfirm,
    onCancel,
}: DeleteConfirmationModalProps) {
    return (
        <StanModal
            id='delete-confirmation-modal'
            isOpen={isOpen}
            onClose={onCancel}
            title='Are you sure?'
            primaryActionDisabled={false}
            primaryActionLoading={isDeleting}
            primaryActionColor='destructive'
            primaryActionLabel={itemType === 'product' ? 'Delete Product' : 'Delete Section'}
            onPrimaryAction={onConfirm}
            size='sm'
            secondaryActionDisabled={false}
            secondaryActionLabel='Cancel'
            onSecondaryAction={onCancel}
        >
            <p className='text-dark text-body-2-regular text-center'>
                Just confirming that you want to delete &ldquo;{itemTitle}&rdquo;. This action cannot be undone.
            </p>
        </StanModal>
    );
}
